module.exports = __webpack_public_path__ + "media/images/affiliation_logos/affiliate_logo_harvard-03115219b2363d09f2caa8399529012c.png";